<div class="loader-container loader-full-size" [class.hide]="!show">
  <div class="overlay loader-full-size"></div>
  <rds-loader width="90px" height="90px"></rds-loader>
</div>
